<ng-container *ngLet="threadService.isActive | async as hasActiveThread">
    <p-ai-chat-trigger-button
        [ngClass]="{ hide: hasActiveThread }"
        [action]="hasActiveThread ? 'init' : 'close'"
        (actionChanged)="threadEventChanged($event)"
    ></p-ai-chat-trigger-button>
    <p-ai-chat-window [isAssistantWorking]="!!(assistantWorking$ | async)" cdkDrag [cdkDragDisabled]="!isDraggable"
                      [cdkDragBoundary]="draggableBoundarySelector" [isDraggable]="isDraggable"
                      [currentLayout]="currentLayout"
                      [canvasAvailable]="frameStore.isOpen()"
                      (layoutChange)="setLayout($event)"
                      *ngIf="showFloat"
                      [@floatSlide]="currentLayout"
                      (@floatSlide.done)="onFloatAnimDone($event)"
                      [ngClass]="aiChatWindowCustomClass">
        <p-ai-chat-window-content (mousedown)="$event.stopPropagation()"/></p-ai-chat-window>
</ng-container>
